import React from 'react';
import { pdf } from '@react-pdf/renderer';
import TreatmentPlanPDF from '../pdf/TreatmentPlanPDF';
import { getOrganizationCurrency } from './currencyUtils';

export async function createTreatmentPlanBlob(plan) {
  if (!plan) throw new Error('Treatment plan data is required for PDF');
  const currency = await getOrganizationCurrency();
  const organization = plan?.organization || null;
  const clinic = plan?.clinic || plan?.patient?.registeredClinic || null;
  const instance = pdf(
    <TreatmentPlanPDF
      plan={plan}
      organization={organization}
      clinic={clinic}
      currency={currency}
    />
  );
  const blob = await instance.toBlob();
  return blob;
}

export async function downloadTreatmentPlanPDF(plan) {
  try {
    const blob = await createTreatmentPlanBlob(plan);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    const planName = (plan.name || 'Treatment_Plan').replace(/\s+/g, '_');
    const patientName = (plan.patient?.name || 'Patient').replace(/\s+/g, '_');
    const fileName = `TreatmentPlan_${planName}_${patientName}_${plan._id || 'PLAN'}.pdf`;
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  } catch (err) {
    console.error('Treatment plan PDF download error:', err);
    throw new Error(err?.message || 'Failed to generate treatment plan PDF');
  }
}

export async function openTreatmentPlanPDF(plan) {
  try {
    const blob = await createTreatmentPlanBlob(plan);
    const url = URL.createObjectURL(blob);
    const w = window.open(url, '_blank');
    if (!w) throw new Error('Popup blocked. Allow popups for this site to print.');
  } catch (err) {
    console.error('Treatment plan PDF open error:', err);
    throw new Error(err?.message || 'Failed to generate treatment plan PDF');
  }
}
